define('modules/editor/models/property_groups/page_defaults',['require','exports','module','./base'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base");

  module.exports = BasePropertyGroup.extend({
    name: "page:defaults",
    properties: ["width", "marginTop", "backgroundColor", "color", "linkColor", "language", "fontFamily"],
    applyStyles: function($el){

    },
    validators: {
      "width": function(attrs){
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isInteger(value) && (value >= 100);
      },
      "marginTop": function(attrs){
        var value = parseInt(attrs.marginTop);
        return this.isInteger(attrs.marginTop) && this.isInteger(value) && (value >= 0);
      }
    }
  });
});

